import { render } from "./chat_title.vue?vue&type=template&id=e9d70b10"
import script from "./chat_title.js?vue&type=script&lang=js"
export * from "./chat_title.js?vue&type=script&lang=js"

import "./chat_title.vue?vue&type=style&index=0&id=e9d70b10&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__